import React from 'react';
import Constant from '../../Constant';
import FadeInSection from '../FadeInSection';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import { motion } from 'framer-motion';

function Trust() {
    const keyFeatures = [
        {
            icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Certified by Shariah Advisory Boards.',
        },
        {
            icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Partnered with SEC-regulated funds.',
        },
        {
            icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Transparent performance reports available anytime.',
        }
    ];



    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    };

    const item = {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    };

    return (
        <FadeInSection>
            <div className="pt-[100px] px-6 sm:px-24 bg-text-gray min-h-screen">
                <h1 className="text-text-color1 font-normal text-[24px] sm:text-[44px] mb-8 ">
                    Trust <span className={Constant.linearColor}>& Security</span>
                </h1>
                {/* <p className="text-[14px] mb-10 font-normal text-text-color1 sm:text-[20px]"> */}
                {/* <p className="mt-4 text-[14px] mb-10 sm:text-[18px] font-[400] text-text-color1">
                    Put aside a lump sum you don’t want to touch and let it work for you with Trust Savings.
                    Simply deposit your funds, lock them in for a chosen period, and watch your wealth grow the halal way.
                    Perfect for safeguarding money meant for future needs - whether it’s a home purchase, education, or a major life milestone -Trust Savings helps you stay disciplined while ensuring your funds remain ethically invested and interest-free.        
                </p> */}

                <div className="grid sm:grid-cols-2 gap-6">
                    <motion.div
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true }}
                        variants={container}
                        className="flex flex-col"
                    >
                        <motion.h2 variants={item} className="text-text-color1 font-normal text-[18px] sm:text-[24px] mb-4">
                            Features
                        </motion.h2>
                        <motion.ul variants={container} className="space-y-3">
                            {keyFeatures.map((feature, index) => (
                                <motion.li key={index} variants={item} className="flex items-center gap-3">
                                    <div
                                        className="w-8 h-8 rounded-full flex items-center justify-center"
                                        style={{ backgroundColor: '#F5F1FE' }}
                                    >
                                        {feature.icon}
                                    </div>
                                    <span className="text-[14px] sm:text-[16px] font-[400] text-text-color1">
                                        {feature.text}
                                    </span>
                                </motion.li>
                            ))}
                        </motion.ul>
                    </motion.div>

                    
                </div>

                <p className="mt-4 text-[14px] mb-10 sm:text-[18px] font-[400] text-text-color1 italic">
                    Your money is managed with integrity, safeguarded with professionalism, and aligned with your values.        
                </p>
            </div>
        </FadeInSection>
    );
}

export default Trust;